<ng-container *ngIf="!loading">
  <div #left class="left" [ngClass]="{ 'resizable': enableResize }">
    <ng-container *ngTemplateOutlet="leftSideTemplate"></ng-container>
  </div>
  <div #right class="right custom-scrollbar" [ngClass]="{ 'resizable': enableResize }">
    <ng-container *ngTemplateOutlet="rightSideTemplate"></ng-container>
  </div>
</ng-container>
<app-loading *ngIf="loading" [displayLogo]="true">
  <p>{{ T.common.loading | translate }}...</p>
</app-loading>
